import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { moodboards } from '../data/dummyData';

const MoodboardSelector = ({ entityType, entityId, onSelect }) => {
  const [selectedMoodboardId, setSelectedMoodboardId] = useState('');
  const [showSelector, setShowSelector] = useState(false);
  const [associatedMoodboard, setAssociatedMoodboard] = useState(null);
  
  // Find moodboards associated with this entity (album or song)
  useEffect(() => {
    const foundMoodboard = moodboards.find(m => 
      m.associationType === entityType && m.associationId === entityId
    );
    setAssociatedMoodboard(foundMoodboard);
  }, [entityType, entityId]);
  
  // Get all moodboards except the one already associated
  const availableMoodboards = moodboards.filter(m => 
    !(m.associationType === entityType && m.associationId === entityId)
  );
  
  const handleLinkMoodboard = () => {
    if (selectedMoodboardId) {
      // In a real app, this would update the backend
      console.log(`Linking moodboard ${selectedMoodboardId} to ${entityType} ${entityId}`);
      onSelect(selectedMoodboardId);
      setShowSelector(false);
      
      // For demo purposes, update the local state
      const selected = moodboards.find(m => m.moodboardId === selectedMoodboardId);
      setAssociatedMoodboard(selected);
    }
  };
  
  const handleCreateNewMoodboard = () => {
    // In a real app, this would open a modal to create a new moodboard
    alert('Create new moodboard modal would open here');
  };
  
  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium text-gray-800 mb-2">Moodboard</h3>
      
      {associatedMoodboard ? (
        <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-medium text-gray-800">{associatedMoodboard.title}</h4>
              <p className="text-sm text-gray-600">{associatedMoodboard.description}</p>
            </div>
            <Link 
              to={`/moodboards/${associatedMoodboard.moodboardId}`}
              className="px-3 py-1 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors text-sm"
            >
              View
            </Link>
          </div>
          
          <div className="mt-3 flex justify-end">
            <button 
              className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
              onClick={() => setShowSelector(true)}
            >
              Change moodboard
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow-sm p-4 border border-dashed border-gray-300 flex flex-col items-center justify-center text-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <p className="text-gray-600 mb-3">No moodboard associated with this album</p>
          <Button 
            variant="outline" 
            onClick={() => setShowSelector(true)}
          >
            Link a moodboard
          </Button>
        </div>
      )}
      
      {showSelector && (
        <div className="mt-4 bg-white rounded-lg shadow-sm p-4 border border-gray-200">
          <h4 className="font-medium text-gray-800 mb-3">Select a moodboard</h4>
          
          {availableMoodboards.length > 0 ? (
            <>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 mb-4"
                value={selectedMoodboardId}
                onChange={(e) => setSelectedMoodboardId(e.target.value)}
              >
                <option value="">Select a moodboard</option>
                {availableMoodboards.map(moodboard => (
                  <option key={moodboard.moodboardId} value={moodboard.moodboardId}>
                    {moodboard.title}
                  </option>
                ))}
              </select>
              
              <div className="flex justify-between">
                <Button 
                  variant="outline" 
                  onClick={() => setShowSelector(false)}
                >
                  Cancel
                </Button>
                <Button 
                  variant="primary" 
                  onClick={handleLinkMoodboard}
                  disabled={!selectedMoodboardId}
                >
                  Link moodboard
                </Button>
              </div>
            </>
          ) : (
            <div className="text-center py-4">
              <p className="text-gray-600 mb-3">No available moodboards found</p>
              <Button 
                variant="primary" 
                onClick={handleCreateNewMoodboard}
              >
                Create new moodboard
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MoodboardSelector;
